module.exports = __webpack_public_path__ + "static/media/dropbox_icon.c3d436ef.svg";